const PromoSignup = [
  "Enter Your\nDetails",
  "Review Your\nPlan",
  "Make Payment",
];

export default PromoSignup;
